<mat-dialog-content>
  <form [formGroup]="orderForm" class="order-form">
    <div class="mb-3">
      <label for="companyName" class="form-label">Order Name*</label>
      <input id="companyName" class="form-control" type="text" formControlName="companyName"
             [maxlength]="COMPANY_NAME_MAX_CHARS" required autocomplete="off">
      <div *ngIf="companyName?.invalid && (companyName?.dirty || companyName?.touched)"
           class="alert alert-danger">
        <div *ngIf="companyName?.errors?.['required']">Order name is required.</div>
        <div *ngIf="companyName?.errors?.['maxlength']">Order name cannot exceed
          {{COMPANY_NAME_MAX_CHARS}} characters.</div>
      </div>
    </div>

    <div class="mb-3">
        <label for="orderType" class="form-label">Order Type*</label>
        <mat-select id="orderType" class="form-control" formControlName="orderType">
          <mat-option value="NEW">New</mat-option>
          <mat-option value="EXISTING">Existing</mat-option>
          <mat-option value="DEACTIVATION">Deactivation</mat-option>
          <mat-option value="SWAP">Swap</mat-option>
        </mat-select>
        <div *ngIf="orderType?.invalid && (orderType?.dirty || orderType?.touched)"
             class="alert alert-danger">
          <div *ngIf="orderType?.errors?.['required']">Order Type is required.</div>
        </div>
    </div>
    <button class="btn btn-light order-form-button" type="submit"
            (mousedown)="prevent($event)" (click)="cancel()">CANCEL</button>
    <button class="btn btn-primary order-form-button" type="submit"
            (click)="submit()" [disabled]="orderForm.invalid">SUBMIT</button>
  </form>
</mat-dialog-content>
